import {
  Flex,
  Heading,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  Button,
  TrackScrolledIntoView
} from '@homebotapp/hb-react-component-catalog'
import { Link as ReactRouterLink } from 'react-router-dom'
import { defineMessages, useIntl } from 'react-intl'
import { useContext, useEffect, useState } from 'react'
import { PATH_HELPERS } from '../../../constants/navigation'
import { selectHomeId } from '../../../store/selectors/home'
import { selectClientFetchId } from '../../../store/selectors/client'
import { HomeownerDigestTrackingEventLocation } from '../../../constants/tracking'
import { useAvmModuleContext } from '../../shared/AvmModule/AvmModuleContext'
import { useAppSelector } from '../../../store/hooks'
import { useAppLayoutContext } from '../../../App/Layout/AppLayout'
import { hveStates } from '../../shared/AvmModule/AvmModuleConstants'

const MSG = defineMessages({
  eyebrowHeading: {
    id: 'HomePriceIndexBlockingModal.eyebrowHeading',
    defaultMessage: 'Takes about 2 minutes'
  },
  heading: {
    id: 'HomePriceIndexBlockingModal.heading',
    defaultMessage: 'Your Homebot is almost ready'
  },
  body: {
    id: 'HomePriceIndexBlockingModal.body',
    defaultMessage: 'Double check some info to see what your home could be worth'
  },
  cta: {
    id: 'HomePriceIndexBlockingModal.cta',
    defaultMessage: "Get your home's value"
  }
})

export const HomePriceIndexWidgetModal = () => {
  const intl = useIntl()
  const context = useAvmModuleContext()
  const appLayoutContext = useAppLayoutContext()
  const showBlockingModal =
    !context.state.wizardCompletedAt &&
    !context.state.wizardInProgress &&
    context.state.clientHveState === hveStates.widget
  const [showModal, setShowModal] = useState(showBlockingModal)
  const homeId = useAppSelector(selectHomeId)
  const clientId = useAppSelector(selectClientFetchId)

  // Check if the user has already completed the widget. If so, don't show the modal. If not, show the modal by default.
  // When the user clicks the CTA to go through the widget flow, hide the modal.
  useEffect(() => {
    setShowModal(showBlockingModal)
  }, [showBlockingModal])

  return (
    <>
      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        trapFocus={false}
        closeOnOverlayClick={false}
        portalProps={{ containerRef: appLayoutContext.layoutOverlayMaskRef }}
      >
        <ModalOverlay top={'var(--toolbar-offset)'} backdropFilter='auto' backdropBlur='4px' />
        <ModalContent
          containerProps={{
            top: 'var(--toolbar-offset, 0px)',
            height: 'calc(var(--chakra-vh) - var(--toolbar-offset, 0px))'
          }}
        >
          <ModalBody marginY='3' marginX='4'>
            <TrackScrolledIntoView
              tracking={{
                guid: 'fUGKRS43NEA42shwzqBhqN',
                descriptor: MSG.heading.defaultMessage,
                ui_context: HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_BLOCKING_MODAL
              }}
            >
              <Flex
                boxSize='12'
                borderRadius='full'
                bg='whiteAlpha.200'
                marginX='auto'
                justifyContent='center'
                alignItems='center'
                marginBottom='2'
              >
                <Icon name='bolt' width='6' height='6' color='brand.500' />
              </Flex>
              <Heading as='h3' variant='eyebrow' color='neutral.500' size='3xs' mb='2'>
                {intl.formatMessage(MSG.eyebrowHeading)}
              </Heading>
              <Heading as='h2' size='sm' fontWeight='semibold' mb='2'>
                {intl.formatMessage(MSG.heading)}
              </Heading>
              <Text textAlign='center' mb='0'>
                {intl.formatMessage(MSG.body)}
              </Text>
            </TrackScrolledIntoView>
          </ModalBody>
          <ModalFooter mb='6'>
            <Button
              as={ReactRouterLink}
              to={PATH_HELPERS.homePriceIndexWidget.buildPath(clientId, homeId)}
              mx='auto'
              colorScheme='brand'
              onClick={() => {
                context.state.setWizardInProgress(true)
              }}
              tracking={{
                guid: 'hJJ9AUjbDr1EcLP6PvenTN',
                descriptor: MSG.cta.defaultMessage,
                ui_context: HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_BLOCKING_MODAL_BUTTON
              }}
              data-qa='HomePriceIndexBlockingModal.cta'
            >
              {intl.formatMessage(MSG.cta)}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
